import React, { useState } from "react";
import { getHexWithOpacity } from "./../../utils/utilityFunctions/stringUtility";

const TableDashboard = ({ IconsList, StatusList, handleDashBoardStatusFilter }) => {
  const [active, setActive] = useState(null);

  const handleFilterStatus = (value) => {
    handleDashBoardStatusFilter(value);
    setActive(value);
  };
  console.log("StatusList", active);
  return (
    <>
      <div className="w-full flex sm:flex-wrap md:flex-wrap lg:flex-wrap  min-h-0 gap-2 py-2 px-1">
        {StatusList?.map((data, index) => {
          const isDefault = active === null && data?.value === "all_task";
          const isActive = isDefault || active === data?.value;

          return (
            <div
              key={index}
              onClick={() => handleFilterStatus(data?.value)}
              style={{
                transition: "background-color 0.2s, border-color 0.2s",
                borderColor: isActive ? data?.color : "#F3F3F3",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = getHexWithOpacity(data?.color, 10))}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "")}
              className="flex min-w-0 grow items-center gap-x-4 py-2 px-3 justify-start border rounded-md cursor-pointer"
            >
              {/* <span
                style={{ borderColor: getHexWithOpacity(data?.color, 40) }}
                className="flex items-center justify-center border w-12 h-12 rounded-full p-2 flex-shrink-0"
              > */}
              {/* {IconsList[data?.value]} */}
              {/* </span> */}
              <span className="flex flex-col items-start">
                <h4
                  style={{ color: data?.color }}
                  className="text-sm sm:text-[10px] md:text-base lg:text-lg font-semibold truncate"
                >
                  {data?.count}
                </h4>
                <h1 className="text-xs md:text-[8px] lg:text-sm xl:text-md  text-[#7B7B7B] font-medium truncate">
                  {data?.label}
                </h1>
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TableDashboard;
